import { ContractsProfileRootPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/contracts/lib/ProfileCollectionsBootstrap'
import Cell from 'modules/contracts/pages/ContractVersionsPage/Cell'
import { RouteProvider } from 'modules/contracts/pages/ContractVersionsPage/_RouteContext'

const Container = () => {
  const { navigation } = useNavigation()
  const { employee: currentEmployee } = useCurrentSession()

  const { data, loading } = useQuery(ContractsProfileRootPageDocument, {
    variables: {
      employeeId: currentEmployee.id,
    },
    skip: !currentEmployee.id,
  })

  if (loading) {
    return <Loading />
  }

  const graphqlContractVersions = data?.contracts.contractVersionsConnection.nodes

  if (!currentEmployee) return null

  return (
    <RouteProvider
      baseRoute={{
        contractVersionPath: (contractVersionId: string) =>
          navigation.profile.contractVersions.contractVersionId.fullPath({ contractVersionId }),
      }}
    >
      <Cell graphqlContractVersions={graphqlContractVersions} employeeId={currentEmployee.id} />
    </RouteProvider>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
